import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getIndex' })
export class GetIndexPipe implements PipeTransform {
  transform(data: any[], item: any) {
    return data.findIndex((i) => i === item);
  }
}
